import { nhost } from "./client";

export const ACCESS_TOKEN_REFRESH_MARGIN_SECONDS = 60;

export async function getFreshAccessToken(
  refreshMarginSeconds = ACCESS_TOKEN_REFRESH_MARGIN_SECONDS
): Promise<string | null> {
  if (!nhost.getUserSession()?.accessToken) {
    return null;
  }

  await nhost.refreshSession(refreshMarginSeconds);
  return nhost.getUserSession()?.accessToken ?? null;
}

export async function requireFreshAccessToken(): Promise<string> {
  const accessToken = await getFreshAccessToken();
  if (!accessToken) {
    throw new Error("You must be signed in.");
  }
  return accessToken;
}

export async function getFreshAuthorizationHeader(): Promise<{ Authorization: string }> {
  const accessToken = await requireFreshAccessToken();
  return { Authorization: `Bearer ${accessToken}` };
}
